// extracted by mini-css-extract-plugin
module.exports = {"card":"ItemAssociation-module__card___1gxOS","detailsRow":"ItemAssociation-module__detailsRow___24xEQ","selectorRow":"ItemAssociation-module__selectorRow___3ee8t"};